import React from 'react';
import classNames from 'classnames';
import UIButton from 'Components/UIComponents/UIButton';

import { UploaderPageTypes } from '../common/constant';

type ButtonPriority = 'primary' | 'secondary';

interface LandingUploaderActionButtonProps {
  handleClick?: () => void;
  title: string;
  priority: ButtonPriority;
  buttonClassName?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

interface LandingUploaderDefaultActionsProps extends LandingUploaderActionButtonProps {
  uploadTitle: string;
  pageType: UploaderPageTypes;
}

interface LandingUploaderProcessedActionsProps extends LandingUploaderActionButtonProps {
  titleClassName?: string;
  containerClassName?: string;
  disabled?: boolean;
  isLoading?: boolean;
}

const LandingUploaderActionButton = ({
  buttonClassName,
  ...restProps
}: LandingUploaderActionButtonProps) => (
  <div className="upload__content-button">
    <UIButton className={buttonClassName} {...restProps} />
  </div>
);

const LandingUploaderDefaultActions = ({
  uploadTitle,
  pageType,
  ...restProps
}: LandingUploaderDefaultActionsProps) => (
  <div
    className={classNames('upload__content', 'sign-up-landing__upload-button', {
      [pageType]: pageType,
    })}
  >
    <LandingUploaderActionButton {...restProps} />
    <div className="upload__content-item upload__text upload__text--gray">Or</div>
    <div className="upload__title upload__content-item">{uploadTitle}</div>
  </div>
);

const LandingUploaderProcessedActions = ({
  titleClassName,
  containerClassName,
  ...restProps
}: LandingUploaderProcessedActionsProps) => (
  <div
    className={classNames(
      'upload__content',
      'sign-up-landing__upload-button',
      containerClassName,
    )}
  >
    <div className={titleClassName}>Don&apos;t see your document?</div>
    <LandingUploaderActionButton {...restProps} />
  </div>
);

interface LandingUploaderActionsProps {
  buttonText?: string;
  buttonClassName?: string;
  buttonPriority: ButtonPriority;
  disabled?: boolean;
  isError: boolean;
  isFileProcessed: boolean;
  pageType: UploaderPageTypes;
  submitting: boolean;
  uploadTitle?: string;
  reopenInteract?: () => void;
}

export const LandingUploaderActions = ({
  buttonText,
  buttonClassName,
  buttonPriority,
  disabled,
  isError,
  isFileProcessed,
  pageType,
  submitting,
  uploadTitle,
  reopenInteract,
}: LandingUploaderActionsProps) => {
  const defaultProps = {
    buttonClassName,
    priority: buttonPriority,
    isLoading: submitting,
  };

  if (isFileProcessed && !isError) {
    const titleClassName =
      pageType === UploaderPageTypes.BLOG
        ? classNames(
            'upload__title upload__title-header',
            'sign-up-landing__upload-subtitle blog',
          )
        : 'upload__title upload__content-item';

    return (
      <LandingUploaderProcessedActions
        {...defaultProps}
        handleClick={reopenInteract}
        title="Click here"
        buttonClassName={
          pageType === UploaderPageTypes.BLOG
            ? classNames('sign-up-landing__upload-button', {
                [pageType]: pageType,
              })
            : undefined
        }
        containerClassName={
          pageType === UploaderPageTypes.BLOG
            ? 'sign-up-landing__upload-content--container'
            : undefined
        }
        titleClassName={titleClassName}
      />
    );
  }

  if (pageType === UploaderPageTypes.BLOG) {
    return (
      <LandingUploaderActionButton
        {...defaultProps}
        title={buttonText || ''}
        disabled={disabled}
      />
    );
  }

  return (
    <LandingUploaderDefaultActions
      {...defaultProps}
      title={buttonText || ''}
      uploadTitle={uploadTitle || ''}
      pageType={pageType}
      disabled={disabled}
    />
  );
};
